$(document).ready(function () {
    var shopsOverviewContainer = $(".shops-overview-container").first();
    if (!shopsOverviewContainer.length) {
        return;
    }
    var map = $("#map-europe");
    map.CSSMap({"size": 960, "mapStyle": "dark", "tooltips": true, "responsive": "auto", "tapOnce": true});
    map.show();
});
